import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../shared/common.service';
import { StorageService, StorageKey } from '../../shared/storage.service';
import { Router } from '@angular/router';
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { FooterService } from '../../components/footer/footer.service';
declare const $: any;
@Component({
  selector: 'app-personal-information',
  templateUrl: './personal-information.component.html',
  styleUrls: ['./personal-information.component.css']
})
export class personalInformation implements OnInit {
  profileImageUrl: string = 'assets/images/userphoto.png'; 
  profileLetter: string;
  @ViewChild('fileInput') fileInput: ElementRef;
  userProfile: any;
  errorMessage: string = '';
  passwordFieldType: string = 'password';
  showPassword: boolean = false;
  showPopup: boolean = false;
  isPasswordValid: boolean = false;
  passwordCriteria = {
    minLength: false,
    upperCase: false,
    lowerCase: false,
    number: false,
    specialChar: false
  };

  constructor(
    private router: Router,
    public commonService: CommonService,
    public userLayoutService: UserLayoutService,
    public storageService: StorageService,
    private footerService: FooterService
  ) { }

  ngOnInit(): void {
    this.footerService.hideFooter();
    this.fetchUserProfile();
  }

  loadProfileImage(): void {
    const storedImageUrl = localStorage.getItem('profileImage');
    if (storedImageUrl) {
      this.profileImageUrl = storedImageUrl;
    }
  }

  onChangePhoto(): void {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      this.uploadProfileImage(file);
    }
  }

  uploadProfileImage(file: File): void {
    const formData = new FormData();
    formData.append('image', file);

    this.userLayoutService.UpdateProfileImage(formData).subscribe(
      (response: any) => {
        if (response.code === 1) {
          this.profileImageUrl = response.data.image;
          this.commonService.notifier.notify('success', 'Profile image updated successfully');
        } else {
          this.commonService.notifier.notify('error', response.message);
        }
      },
      (error) => {
        // console.log('Update Family Member API Error:', error);
        this.commonService.notifier.notify('error', 'Failed to update family member');
      }
    );
  }

  // Method to fetch user profile using token
  fetchUserProfile(): void {
    const userId = this.storageService.getValue(StorageKey.id);

    if (userId) {
      const profileData = { userId: userId };

      this.userLayoutService.UserProfile(profileData).subscribe((response: any) => {
        if (response.code === 1) {
          this.userProfile = response.data;
          this.profileImageUrl = response.data.imagePath;
          localStorage.setItem('profileImage', this.profileImageUrl);
          // console.log("ProfileData", this.userProfile);
          if (this.userProfile.firstName) {
            this.profileLetter = this.userProfile.firstName.charAt(0).toUpperCase();
          }
        } else {
          this.errorMessage = response.message;
          this.commonService.notifier.notify('error', response.message);
        }
      },
        (error) => {
          this.errorMessage = 'Failed to fetch profile data';
          // console.log('Profile API Error:', error);
          this.commonService.notifier.notify('error', this.errorMessage);
        });
    } else {
      this.errorMessage = 'No user ID found. Please log in.';
      this.commonService.notifier.notify('error', this.errorMessage);
    }
  }

  updateUserProfile(): void {
    const userId = this.storageService.getValue(StorageKey.id);
    this.closeUpperModel(null, 'editinformationSidebar');
    if (userId) {
      const updatedProfile = {
        firstName: this.userProfile.firstName,
        lastName: this.userProfile.lastName,
        email: this.userProfile.email,
        password: this.userProfile.password
      };

      this.userLayoutService.updateUserProfile(updatedProfile).subscribe((response: any) => {
        if (response.code === 1) {
          this.commonService.notifier.notify('success', 'Profile updated successfully');
          this.updateLocalStorageUserData();
          this.fetchUserProfile();
        } else {
          this.errorMessage = response.message;
          this.commonService.notifier.notify('error', response.message);
        }
      }, (error) => {
        this.errorMessage = 'Failed to update profile data';
        // console.log('Update Profile API Error:', error);
        this.commonService.notifier.notify('error', this.errorMessage);
      });
    } else {
      this.errorMessage = 'User ID or token missing. Please log in.';
      this.commonService.notifier.notify('error', this.errorMessage);
    }
  }


  closeUpperModel(modal: string | null, offcanvas: string | null): void {
    if (modal) {
      $(`#${modal}`).modal('hide');
    }
    if (offcanvas) {
      ($(`#${offcanvas}`) as any).offcanvas('hide');
    }
  }



  goBack(): void {
    this.router.navigate(['profile']);
  }

  validatePassword(password: string): void {
    this.passwordCriteria.minLength = password.length >= 8;
    this.passwordCriteria.upperCase = /[A-Z]/.test(password);
    this.passwordCriteria.lowerCase = /[a-z]/.test(password);
    this.passwordCriteria.number = /[0-9]/.test(password);
    this.passwordCriteria.specialChar = /[@$!%*?&]/.test(password);

    this.isPasswordValid = Object.values(this.passwordCriteria).every((value) => value === true);

    if (this.isPasswordValid) {
      this.showPopup = false;
    }
  }

  onPasswordFocus(): void {
    if (!this.isPasswordValid) {
      this.showPopup = true;
    }
  }

  onPasswordBlur(): void {
    this.showPopup = false;
  }

  togglePasswordVisibility(): void {
    this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
  }

  hidePasswordPopup(): void {
    this.showPassword = false;
  }

  updateLocalStorageUserData(): void {
    const loginUserData = JSON.parse(localStorage.getItem('LoginUserData') || '{}');

    if (loginUserData) {
      // Update local storage data with new first and last name
      loginUserData.firstName = this.userProfile.firstName;
      loginUserData.lastName = this.userProfile.lastName;
      loginUserData.email = this.userProfile.email;
      loginUserData.password = this.userProfile.password;

      // Save updated data back to local storage
      localStorage.setItem('LoginUserData', JSON.stringify(loginUserData));
    }
  }

  onImageError(event: any) {
    event.target.src = 'assets/image/userphoto.png';
  }
}
